import { Component, OnInit, Input } from '@angular/core';
import { UserInfo } from '../../models';

@Component({
    selector: 'app-shared-with',
    templateUrl: './shared-with.component.html',
    styleUrls: ['./shared-with.component.scss'],
    standalone: false
})
export class SharedWithComponent implements OnInit {

  isMe: string;

  @Input() titles: string;
  @Input() sharedWithList: UserInfo[];

  big: boolean;
  @Input('big') set setBig(attribute: boolean | '') {
    this.big = attribute === '' || attribute;
  }

  owner: boolean;
  @Input('owner') set setOwner(attribute: boolean | '') {
    this.owner = attribute === '' || attribute;
  }

  constructor() { }

  async ngOnInit() { }

}
